var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8799 5.82935C12.0256 5.82935 13.1244 6.31177 13.9346 7.17049C14.7448 8.0292 15.1999 9.19387 15.1999 10.4083V15.7504H12.3199V10.4083C12.3199 10.0035 12.1682 9.61526 11.8981 9.32902C11.6281 9.04278 11.2618 8.88197 10.8799 8.88197C10.498 8.88197 10.1317 9.04278 9.86162 9.32902C9.59157 9.61526 9.43985 10.0035 9.43985 10.4083V15.7504H6.55981V10.4083C6.55981 9.19387 7.01496 8.0292 7.82513 7.17049C8.6353 6.31177 9.73412 5.82935 10.8799 5.82935Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.68033 6.59277H0.800293V15.7507H3.68033V6.59277Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.24031 4.30263C3.03561 4.30263 3.68033 3.61927 3.68033 2.77631C3.68033 1.93335 3.03561 1.25 2.24031 1.25C1.44501 1.25 0.800293 1.93335 0.800293 2.77631C0.800293 3.61927 1.44501 4.30263 2.24031 4.30263Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.1019431229d0bfd52a67b3350d947289.svg";
export { ForwardRef as ReactComponent };